/**
 * Sorts routes by descending `priority` (routes with no `priority` are treated as `0`).
 */
/** @knip-ignore only consumed by config/webpack/** and scripts/**, both of which knip's production mode structurally excludes from its reachability graph */
export function sortRoutes<ROUTE extends { priority?: number }>(routes: readonly ROUTE[]): readonly ROUTE[] {
	return [...routes].sort((a, b) => (b.priority || 0) - (a.priority || 0));
}
